export const COMPANY_NAME = '深圳市智起网络科技有限公司'
export const COMPANY_SHORT_NAME = '智起云'



// WEBPACK FOOTER //
// ./src/constants/index.js